import { Service } from '@roc/feature-app-core';
import { CONTENTFUL_KEY } from '../utils/utils';

const url = {
  GET_DOCUMENT_LIBRARY_JSON: '/api/v1/vendor/public/contentful/getDocumentLibraryJson',
  GET_ENTRY_BY_KEY: '/api/v1/vendor/contentful/getEntryByKey',
};

export class DocumentLibraryService extends Service {
  getDocumentLibraryJson(params) {
    return this.get(url.GET_DOCUMENT_LIBRARY_JSON, params);
  }

  getEntryByKey(key: CONTENTFUL_KEY) {
    return this.get(url.GET_ENTRY_BY_KEY, { key });
  }

}
